import { BLOCK_CLASSES as e } from "../../constants.js";
const r = {
  inline: !1,
  content: "(hardBreak | text | inline)*",
  attrs: {
    type: { default: "code" }
  },
  defining: !0,
  group: "block",
  parseDOM: [{ tag: "pre" }],
  toDOM() {
    return [
      "pre",
      {
        class: `${e.code}`
      },
      0
    ];
  },
  marks: ""
};
export {
  r as codeBlockSpec
};
